/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Leave_ConfirmInputs */



/**
* | output |
* | --- |
* | "Leave anyway" |
*
* @param {Meeting_Offline_Leave_ConfirmInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_leave_confirm = /** @type {((inputs?: Meeting_Offline_Leave_ConfirmInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Leave_ConfirmInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Toch verlaten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quitter quand même")
	return /** @type {LocalizedString} */ ("Leave anyway")
});